import React from "react";
import { addTimeStamp } from '../utils';

export const AmberLogo = ( props ) => {
    const {logoWidth, logoOpacity} = props;
    return(
        <img src={addTimeStamp('assets/amberane-logo-sepia.png')} alt='logo-black' style={ { width: logoWidth, opacity: logoOpacity } } />
    );
};